var React = require('react');

function Lines (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#1D1D1B","strokeWidth":".5"},React.createElement("path",{"d":"M0 11.5h965M0 6.5h965M0 .5h965"})));
}

Lines.defaultProps = {"width":"100%","height":"12"};

module.exports = Lines;

Lines.default = Lines;
